module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/user-management/user-management.component.css
// module id = 1010
// module chunks = 1